import { Space } from 'antd';
import moment from 'moment';
import { Trans } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import SearchParam from '../SearchParam';
import FilterButton from './FilterButton';
import StringDatePicker from './StringDatePicker';

interface FilterDateRangeProps {
  start: string;
  end: string;
}

const FilterDateRange = ({ start, end }: FilterDateRangeProps) => {
  const [searchParams] = useSearchParams();

  return (
    <Space direction="vertical">
      <Space direction="horizontal">
        <SearchParam name={start} onSetSearchParams={{ page: '1' }}>
          <StringDatePicker
            allowClear
            data-testid="start-filter-date-range-input"
            format="DD/MM/YYYY"
            disabledDate={(current) => {
              // Days after today are not allowed
              return current && current > moment().endOf('day');
            }}
          />
        </SearchParam>
        <Trans>até</Trans>
        <SearchParam name={end} onSetSearchParams={{ page: '1' }}>
          <StringDatePicker
            allowClear
            data-testid="end-filter-date-range-input"
            format="DD/MM/YYYY"
            disabledDate={(current) => {
              // Days after today are not allowed
              return current && current > moment().endOf('day');
            }}
          />
        </SearchParam>
      </Space>
      <SearchParam
        array
        name={start}
        onSetSearchParams={{ page: '1', [end]: '' }}
        valuePropName="disabledValue"
      >
        <FilterButton disabled={!(searchParams.get(start) || searchParams.get(end))}>
          <Trans>Limpar</Trans>
        </FilterButton>
      </SearchParam>
    </Space>
  );
};

export default FilterDateRange;
